
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/core/services/ApiService";
import { translate, statusColor } from "@/core/services/HelpersFun";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";

export default defineComponent({
  name: "kt-otp-management-table",
  components: {},
  props: {
    widgetClasses: String,
  },
  setup() {
    const loading = ref(true);
    const list = ref();
    const pagination = ref();
    const mobile = ref();
    const page = ref(1);

    const getItems = () => {
      loading.value = true;
      ApiService.query("admin/activation-code", {
        params: { mobile: mobile.value, page: page.value },
      })
        .then(({ data }) => {
          loading.value = false;
          list.value = data.data.codes.data;
          pagination.value = data.data.codes.pagination;
        })
        .catch(() => {
          loading.value = false;
        });
    };

    const handleSizeChange = (val: number) => {
      return;
    };

    const handleCurrentChange = (val: number) => {
      page.value = val;
      getItems();
    };

    onMounted(() => {
      getItems();
      setCurrentPageBreadcrumbs(translate("مدیریت کد‌های تایید"), []);

    });

    return {
      loading,
      pagination,
      getItems,
      translate,
      statusColor,
      mobile,
      list,
      handleSizeChange,
      handleCurrentChange,
    };
  },
});
